<template>
  <ElDialog
    :title="modalTitle"
    :visible="value"
    width="40%"
    :append-to-body="true"
    @close="resetAndClose"
  >
    <EditPriceOfferForm
      :loading="loading"
      :reset-controller="resetController"
      @cancel="resetAndClose"
      @save="edit"
    />
  </ElDialog>
</template>

<script>
import EditPriceOfferForm from './EditPriceOfferForm';

import {
  SELECTED_CAMPAIGN_BIDS,
  EDIT_CAMPAIGN_BIDS,
  CAMPAIGN_BIDS,
} from '@/store/types';

import calculateBidPriceOffer from './calculateBidPriceOffer';

import { mapActions, mapGetters } from 'vuex';

import campaignId from '@/mixins/advertisement/campaignId';

import createController from '@/utils/controller';

function extractPriceOfferAndId(bids) {
  return bids.map(({ id, priceOffer }) => ({ id, priceOffer }));
}

const resetController = createController('reset');

export default {
  name: 'EditBidPriceOfferModal',
  components: {
    EditPriceOfferForm,
  },
  mixins: [campaignId],
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    selectedIds: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      allBids: CAMPAIGN_BIDS,
    }),
    resetController() {
      return resetController;
    },
    isAnyBidsSelected() {
      return this.selectedIds.length;
    },
    selectedBids() {
      return this.$store.getters[SELECTED_CAMPAIGN_BIDS](this.selectedIds);
    },
    bids() {
      if (this.isAnyBidsSelected) {
        return this.selectedBids;
      }
      return this.allBids;
    },
    modalTitle() {
      return this.isAnyBidsSelected
        ? this.$t('ADVERTISEMENT.EDIT_SELECTED_BID_PRICE_OFFER', {
            count: this.selectedIds.length,
          })
        : this.$t('ADVERTISEMENT.EDIT_ALL_BID_PRICE_OFFER');
    },
  },
  methods: {
    ...mapActions({
      editBids: EDIT_CAMPAIGN_BIDS,
    }),
    edit({ value, valueType, type }) {
      this.loading = true;

      const bids = calculateBidPriceOffer({
        bids: this.bids,
        type,
        valueType,
        value,
      });
      return this.editBids({
        campaignId: this.campaignId,
        bidsInfo: extractPriceOfferAndId(bids),
      })
        .then(message => {
          this.$message.success(message);

          this.resetAndClose();
        })
        .catch(({ message }) => {
          this.$message.error(message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    resetAndClose() {
      this.reset();
      this.$emit('input', false);
    },
    reset() {
      this.resetController.reset();
    },
  },
};
</script>
